import React from 'react';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import { LocalForm } from 'react-redux-form';

export const SimpleForm = ({
  onChange,
  form,
  setItem,
  setForm,
  onUpdate,
  onSubmit,
  setDispatch,
  item,
  children,
  dispatch,
  ...props
}) => (
  <LocalForm
    onChange={onChange}
    onUpdate={onUpdate}
    onSubmit={onSubmit}
    getDispatch={setDispatch}
    initialState={item}
    {...props}
  >
    {children({ form, item, dispatch, onSubmit })}
  </LocalForm>
);

const enhance = compose(
  withStateHandlers(
    props => ({
      form: null,
      dispatch: null,
      item: props.initialState,
    }),
    {
      setItem: () => item => ({ item }),
      setForm: () => form => ({ form }),
      setDispatch: () => dispatch => ({ dispatch }),
    }
  ),
  withHandlers({
    onUpdate: ({ setForm }) => form => setForm(form),
    onChange: ({ setItem }) => item => setItem(item),
    setDispatch: ({ setDispatch }) => dispatch => setDispatch(dispatch),
    onSubmit: ({ dispatch, form, item, onSubmit }) => () =>
      onSubmit({ dispatch, form, item }),
  })
);

export default enhance(SimpleForm);



// WEBPACK FOOTER //
// ./src/components/common/Forms/SimpleForm.jsx